import { render, staticRenderFns } from "./order-details.vue?vue&type=template&id=4f29eb0a&"
import script from "./order-details.vue?vue&type=script&lang=js&"
export * from "./order-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports